import React, { useState, useCallback } from 'react'
import Grid from '@material-ui/core/Grid'
import PropTypes from 'prop-types'
import SydButton from '../../../../../../commonDesign/Button'
import SydModalActions from '../../../../../../commonDesign/SydModal/SydModalActions'
import FieldDisplay from '../../../../../../molecules/FieldDisplay'
import { useRemoveQueryBlueprintVersion } from '../../../../../../../api/denali'
import { decipherError } from '../../../../../../../utils/decipherError'

function DeleteVersionForm ({ blueprint, version, onCancel, onComplete }) {
  const { mutateAsync: removeVersion, isLoading: removing } = useRemoveQueryBlueprintVersion()
  const [error, setError] = useState(null)

  const handleDelete = useCallback(async () => {
    try {
      setError(null)
      await removeVersion({
        blueprintId: blueprint.blueprintId,
        definitionVersionId: version.definitionVersionId
      })
      onComplete()
    } catch (err) {
      setError(decipherError(err))
    }
  }, [blueprint.blueprintId, version.definitionVersionId, removeVersion, onComplete])

  const purposeCount = Object.keys(version.data?.purposes || {}).length

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FieldDisplay
          fields={[
            { label: 'Version', value: version.definitionVersionId },
            { label: 'Description', value: version.description || '-' },
            { label: 'Purposes', value: purposeCount },
            { label: 'Created', value: version.versionDate ? new Date(version.versionDate).toLocaleString() : '-' }
          ]}
        />

        <h3 style={{ marginTop: '16px' }}>Are you sure you want to delete this version?</h3>
        <p>This action cannot be undone.</p>
      </Grid>

      {error && (
        <Grid item xs={12}>
          <div style={{ color: 'red', padding: '8px', backgroundColor: '#fee', borderRadius: '4px' }}>
            {error}
          </div>
        </Grid>
      )}

      <Grid item xs={12}>
        <SydModalActions>
          <SydButton disabled={removing} variant='ghost' size='md' onClick={onCancel}>
            Cancel
          </SydButton>
          <SydButton
            processing={removing}
            variant='primary'
            priority='warning'
            icon='delete'
            size='md'
            onClick={handleDelete}
          >
            Delete Version
          </SydButton>
        </SydModalActions>
      </Grid>
    </Grid>
  )
}

DeleteVersionForm.propTypes = {
  blueprint: PropTypes.object.isRequired,
  version: PropTypes.object.isRequired,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default DeleteVersionForm
